import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "withdrawal-container page-content" }
const _hoisted_2 = { class: "amount-card" }
const _hoisted_3 = { class: "amount-header" }
const _hoisted_4 = { class: "amount-input" }
const _hoisted_5 = { class: "bank-card-section" }
const _hoisted_6 = { class: "bank-select" }
const _hoisted_7 = { class: "submit-section" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "drawer-content" }
const _hoisted_10 = { class: "drawer-header" }
const _hoisted_11 = { class: "bank-list" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "bank-info" }
const _hoisted_14 = { class: "bank-detail" }
const _hoisted_15 = { class: "bank-name" }
const _hoisted_16 = { class: "card-no" }
const _hoisted_17 = { class: "password-drawer-container" }
const _hoisted_18 = { class: "drawer-header" }
const _hoisted_19 = { class: "withdrawal-amount-info" }
const _hoisted_20 = { class: "amount-value" }
const _hoisted_21 = { class: "password-input-content" }

import { ref, computed, onMounted, watch } from 'vue';
import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { getCardList, withdraw } from '@/api/wallet';
import { showToast } from 'vant';

// 响应式状态

export default /*@__PURE__*/_defineComponent({
  __name: 'withDrawal',
  setup(__props) {

const amount = ref('');
const cardList = ref<any[]>([]);
const cardInfo = ref<any>({});
const showDrawer = ref(false);
const showFeeInfoModal = ref(false);
const payPassword = ref('');
const showPayPasswordDrawer = ref(false);

// 计算属性：是否可以提交
const canSubmit = computed(() => {
  return Number(amount.value) >= 100 && !!cardInfo.value.linkId;
});

// 全部提现方法
const withdrawAll = () => {
  // TODO: 实现全部提现逻辑
};

// 选择银行卡
const selectBank = (card: any) => {
  cardInfo.value = {
    linkId: card.linkId,
    bankName: card.bankName,
    bankAccountNo: card.bankAccountNo.slice(-4)
  }
  showDrawer.value = false;
}

// 获取银行卡列表
const getList = async () => {
  const res = await getCardList();
  if (res.code === 200) {
    cardList.value = res.data
    if (cardList.value.length > 0) {
      cardInfo.value = {
        linkId: cardList.value[0].linkId,
        bankName: cardList.value[0].bankName,
        bankAccountNo: cardList.value[0].bankAccountNo.slice(-4)
      }
    } else {
      cardInfo.value = {
        linkId: null,
        bankName: null,
        bankAccountNo: null
      }
    }
  }
};

// 提交提现申请
const handleSubmit = async () => {
  if (!amount.value) {
    showToast('请输入提现金额');
    return;
  }
  if (!cardInfo.value.linkId) {
    showToast('请选择银行卡');
    return;
  }

  // 显示密码输入抽屉
  showPayPasswordDrawer.value = true;
  payPassword.value = ''; // 重置密码
};

// 监听密码变化
watch(payPassword, (newValue) => {
  if (newValue.length === 6) {
    handlePasswordComplete();
  }
});

// 处理密码完成
const handlePasswordComplete = async () => {
  try {
    const res = await withdraw({
      amount: Number(amount.value),
      linkId: cardInfo.value.linkId,
      payPassword: payPassword.value
    });

    if (res.code === 200) {
      //打开第三方页面
      window.open(res.data.pageUrl, '_blank');
      // showToast('提现成功');
      showPayPasswordDrawer.value = false;
      amount.value = '';  // 清空金额
      payPassword.value = '';  // 清空密码
    } else {
      showToast(res.msg);
      payPassword.value = '';  // 清空密码以便重新输入
    }
  } catch (error) {
    showToast('提现失败，请重试');
    payPassword.value = '';  // 清空密码以便重新输入
  }
};

// 组件挂载时获取银行卡列表
onMounted(() => {
  getList()
});

return (_ctx: any,_cache: any) => {
  const _component_svgIcon = _resolveComponent("svgIcon")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_dialog = _resolveComponent("van-dialog")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_password_input = _resolveComponent("van-password-input")!
  const _component_van_number_keyboard = _resolveComponent("van-number-keyboard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomTitleBar, { title: "提现" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[11] || (_cache[11] = _createElementVNode("span", null, "提现鲸油", -1)),
        _createVNode(_component_svgIcon, {
          name: "qa",
          color: "#0256FF",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showFeeInfoModal.value = true))
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((amount).value = $event)),
          placeholder: "0.0"
        }, null, 512), [
          [_vModelText, amount.value]
        ]),
        _createElementVNode("div", {
          class: "withdraw-all",
          onClick: withdrawAll
        }, "全部提现")
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "fee-info" }, "提现服务费为3.6%，最低提现鲸油100", -1)),
      _createElementVNode("div", _hoisted_5, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "section-title" }, "提现到", -1)),
        _createElementVNode("div", _hoisted_6, [
          (cardInfo.value.bankName)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "selected-bank",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showDrawer.value = true))
              }, [
                _createElementVNode("span", null, _toDisplayString(cardInfo.value.bankName) + " (" + _toDisplayString(cardInfo.value.bankAccountNo) + ")", 1),
                _createVNode(_component_svgIcon, {
                  name: "arrow_right",
                  size: "10"
                })
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "add-bank",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showDrawer.value = true))
              }, "选择银行卡"))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        class: "submit-btn",
        disabled: !canSubmit.value,
        onClick: handleSubmit
      }, " 提现 ", 8, _hoisted_8),
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "agreement" }, [
        _createTextVNode(" 提现即代表同意"),
        _createElementVNode("span", { class: "link" }, "《鲸宝支付协议》")
      ], -1))
    ]),
    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "bottom-tips" }, [
      _createElementVNode("div", { class: "contact" }, [
        _createTextVNode(" 如有疑问联系鲸宝："),
        _createElementVNode("span", { class: "service" }, "客服")
      ])
    ], -1)),
    _createVNode(_component_van_popup, {
      show: showDrawer.value,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((showDrawer).value = $event)),
      position: "bottom",
      round: "",
      style: { height: '60%' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[15] || (_cache[15] = _createElementVNode("span", null, "选择银行卡", -1)),
            _createElementVNode("span", {
              class: "close-icon",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (showDrawer.value = false))
            }, [
              _createVNode(_component_svgIcon, {
                name: "close",
                size: "20"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardList.value, (card) => {
              return (_openBlock(), _createElementBlock("div", {
                key: card.id,
                class: "bank-item",
                onClick: ($event: any) => (selectBank(card))
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_svgIcon, {
                    name: "bankcard",
                    size: "20"
                  }),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(card.bankName), 1),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(card.bankAccountNo), 1)
                  ])
                ]),
                _createVNode(_component_svgIcon, {
                  name: cardInfo.value.linkId === card.linkId ? 'selected' : 'select',
                  size: "20"
                }, null, 8, ["name"])
              ], 8, _hoisted_12))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_dialog, {
      show: showFeeInfoModal.value,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((showFeeInfoModal).value = $event)),
      title: "提现规则",
      "show-cancel-button": false,
      theme: "round-button",
      "confirm-button-color": "#0256FF",
      onConfirm: _cache[7] || (_cache[7] = ($event: any) => (showFeeInfoModal.value = false))
    }, {
      default: _withCtx(() => _cache[16] || (_cache[16] = [
        _createElementVNode("div", { class: "fee-info-content" }, [
          _createElementVNode("span", null, "1. 单日最高提现次数为 3 次"),
          _createElementVNode("span", null, "2. 单笔最大额度 20000 鲸油，单日累计最大提现金额为 50000 鲸油"),
          _createElementVNode("span", null, "3. 提现费率为 3.6%，请您管理好个人提现次数及金额，以免提现超出限制影响您的使用。")
        ], -1)
      ])),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: showPayPasswordDrawer.value,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((showPayPasswordDrawer).value = $event)),
      position: "bottom",
      style: { height: '60%', borderRadius: '16px 16px 0 0' },
      round: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_van_icon, {
              name: "cross",
              size: "20",
              class: "close-icon",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (showPayPasswordDrawer.value = false))
            }),
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "drawer-title" }, "输入支付密码", -1)),
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "placeholder" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "amount-label" }, "提现", -1)),
            _createElementVNode("div", _hoisted_20, "¥ " + _toDisplayString(amount.value), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_van_password_input, {
              value: payPassword.value,
              length: 6,
              gutter: "10px",
              mask: ""
            }, null, 8, ["value"]),
            _createVNode(_component_van_number_keyboard, {
              modelValue: payPassword.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((payPassword).value = $event)),
              show: true,
              type: "number",
              "extra-key": "",
              "close-button-text": "完成"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})